import type { Activity, Level } from "@app-types/activity-data.types";
import { NavigationButton } from "@components";
import { Box, Typography } from "@mui/material";
import { theme } from "@theme";

type RecommendedTaskProps = {
  recommendedTask: Activity;
  selectedLevel: Level;
  navigateToSelectedActivity: (arg0: Activity) => void;
};

export const RecommendedTask = ({
  recommendedTask,
  selectedLevel,
  navigateToSelectedActivity,
}: RecommendedTaskProps) => {
  return (
    <Box
      sx={{
        marginTop: 3,
        padding: 3,
        borderRadius: 5,
        background: theme.palette.info.light,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 1fr) auto",
          padding: 1.625,
          border: `1px solid ${theme.palette.info.main}`,
          borderRadius: 2,
          background: theme.palette.secondary.main,
          textAlign: "left",
        }}
      >
        <Box>
          <Typography
            sx={{
              background: theme.palette.text.primary,
              color: theme.palette.primary.contrastText,
              padding: "2px 8px",
              fontSize: "0.75rem",
              fontWeight: 700,
              borderRadius: 1,
              width: "fit-content",
              marginBottom: 0.75,
            }}
          >
            NEXT RECOMMENDED TASK
          </Typography>
          <Typography sx={{ fontWeight: 700 }}>
            {recommendedTask.title}
          </Typography>
          <Typography sx={{ fontSize: "0.875rem" }}>
            Tool: {recommendedTask.tool.replace("-ai", "").toUpperCase()} •
            Level: {selectedLevel.toUpperCase()} • Est:{" "}
            {recommendedTask.content.estimatedTime}
          </Typography>
        </Box>
        <NavigationButton
          onClick={() => navigateToSelectedActivity(recommendedTask)}
          sx={{
            height: "fit-content",
            padding: "8px 20px",
            alignSelf: "center",
          }}
        >
          Begin this Task
        </NavigationButton>
      </Box>
    </Box>
  );
};
